export function portalRoutePath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] === 'vendors') segments.shift();
  segments.shift(); // marketplace slug
  return `/${segments.join('/')}`;
}

export function portalPageEnabled(path: string, visibility?: Record<string, boolean>): boolean {
  // Missing authority means loading/unavailable. Default-on settings are
  // expanded by the server into a successfully fetched complete map.
  if (!visibility) return false;
  try { path = decodeURIComponent(path).toLowerCase(); } catch { return false; }
  const key = Object.keys(visibility || {}).filter(k => path === k || path.startsWith(`${k}/`))
    .sort((a, b) => b.length - a.length)[0];
  return !key || visibility[key] === true;
}
export const PORTAL_PAGE_PATHS = [
  '/dashboard', '/products', '/menu', '/inventory', '/offers', '/grocery/unit-pricing', '/orders',
  '/returns', '/disputes', '/delivery', '/availability', '/slots', '/console', '/payouts',
  '/payouts/method', '/statements', '/invoices', '/coupons', '/analytics', '/ai/forecast',
  '/ai/listing-quality', '/storefront', '/referrals', '/messages', '/reviews', '/questions',
  '/notifications', '/support', '/support/cases', '/support/shopper-cases', '/profile', '/activity',
] as const;

export function isPortalNavigation(value: unknown): value is Record<string, boolean> {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const map = value as Record<string, unknown>;
  return PORTAL_PAGE_PATHS.every(path => typeof map[path] === 'boolean')
    && Object.values(map).every(item => typeof item === 'boolean');
}
